import { Link } from 'react-router-dom';
import PolicyLayout from './PolicyLayout';
import { COMPANY_NAME, POLICY_UPDATED, SALES_EMAIL } from '../constants/site';

export default function Authenticity() {
  return (
    <PolicyLayout
      title="Authenticity"
      updated={POLICY_UPDATED}
      intro="Every licence sold here is an authentic publisher-issued licence. This page explains how we source them and how you can verify it yourself."
    >
      <h2>Where the licences come from</h2>
      <p>
        {COMPANY_NAME} supplies accounting software licences as an authorised reseller. Keys are
        issued by the software publisher against your order and registered to your business, not
        transferred from a pool of second-hand or volume keys.
      </p>

      <h2>How to verify your licence</h2>
      <p>
        Open your accounting software and check the product and licence numbers in the About
        or Product Information screen, then sign in to your publisher account and confirm the
        same licence appears under your products. If the two do not match, contact us before
        using the software.
      </p>

      <h2>Downloads</h2>
      <p>
        We only ever send official publisher download links. If you receive an installer for
        accounting software from any source other than the publisher, do not run it.
      </p>

      <h2>What we will not sell</h2>
      <p>
        We do not sell keygens, cracked builds, academic keys resold for commercial use or
        licences pulled from decommissioned machines. If a price looks impossible elsewhere,
        that is usually why.
      </p>

      <h2>If a key fails to activate</h2>
      <p>
        Email <a href={`mailto:${SALES_EMAIL}`}>{SALES_EMAIL}</a> with the licence number and
        the activation message. We replace a non-activating key at no cost, or refund it in
        full under our <Link to="/return-policy">return policy</Link>.
      </p>
    </PolicyLayout>
  );
}
